import React, { useState, useContext } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import UserProfile from './UserProfile';
import UserWallet from './UserWallet';
import UserSubscriptions from './UserSubscriptions';
import { UserContext } from '../../../hooks';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const { user, updateUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Tabs value={activeTab} onChange={handleTabChange} centered>
        <Tab label="Perfil" />
        <Tab label="Suscripciones" />
        {/*<Tab label="Mis Pedidos" />*/}
        <Tab label="Monedero" />
      </Tabs>
      {activeTab === 0 && <UserProfile />}
      {activeTab === 1 && (
        <UserSubscriptions
          user={user}
          updateUser={updateUser}
          navigate={navigate}
        />
      )}
      {/*{activeTab === 2 && <UserOrders />}*/}
      {activeTab === 2 && <UserWallet user={user} />}
    </Box>
  );
};

export default Profile;
